module.exports = __webpack_public_path__ + "img/home-banner.790cf601.png";